import { FC } from "preact/compat";
import { Navigate } from "react-router-dom";
import ACCESS from "~/core/access";
import { me } from "~/core/store";
import { useAccessCheck } from "~/hooks";

const redirects = [
    ["admin/time", ACCESS.adminTime],
    ["admin/expenses", ACCESS.adminExpenses],
    ["admin/approval", ACCESS.adminApproval],
    ["admin/tasks", ACCESS.adminTasks],
] as const;

const AdminRedirect: FC = () => {
    const { isLoading, check } = useAccessCheck();

    if (isLoading) {
        return null;
    }

    // if none pages are accessible, default to time page
    // it will perform its own check and redirect user
    //
    const [path] =
        redirects.find(([, access]) => check(access)) ?? redirects[0];

    return <Navigate to={me(path)} replace />;
};

export default AdminRedirect;
